import React, {useState, useEffect} from 'react';
import {Snackbar, Grid, Backdrop, Typography, CircularProgress, ListItem, ListItemIcon, ListItemText, Button} from '@material-ui/core/';
import Alert from "@material-ui/lab/Alert";
import {NavigateNext, Send, ListAlt, RestaurantMenu} from '@material-ui/icons';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import { useHistory } from "react-router-dom";
import {AccountCircle, Email, Filter1, VpnKey } from '@material-ui/icons';
import Form from 'components/Form/FormTwoColumns';
import DatosCiudadano from './DatosCiudadano'
import {functions} from 'constants/index';
import ApiServices from 'services/ApiServices';
import LoadingSpinner from "components/LoadingSpinner";
import { showMessageSuccessSimple, showMessagePersonalizedPosition } from 'services/SweetAlert';
import ComponenteReportarCasoAInformatica from './ReportarCasoAInformatica'
import DatosResidenciaElectoralActualPadron from './DatosResidenciaElectoralActual'
import DialogLoadingMessage from 'components/BackDrop';

function DatosCiudadanoRENAP(props) {
    let history = useHistory();
    const classes = useStyles(),
        [apiErrors,setApiErrors] = useState([]),
        [cargandoDatos, setCargandoDatos] = useState(true),
        [loadingStateCity, setLoadingStateCity] = useState({loading:false, title:''}),
        [dejarEmpadronar, setDejarEmpadronar] = useState(false),
        [analfabeta, setAnalfabeta] = useState(props.datosCiudadanoTable.alfabetismo),
        [noVidente, setNovidente] = useState(props.datosCiudadanoTable.noVidente),        
        // [residenciaElectoralActual, setResidenciaElectoralActual] = useState({}),
        [openAlertaGeneral, setOpenAlertaGeneral] = useState(true),
        [abrirModalReportarCasoInformatica, setAbrirModalReportarCasoInformatica] = useState(false);
        let residenciaElectoralActual = {};
        let municipioVecindadActual = {id: props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.municipioVecindad?.id?.id, name: props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.municipioVecindad?.name}
        let municipioNacimientoActual = {id: props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.municipioNacimieno?.id?.id, name: props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.municipioNacimieno?.name}
        let idDepartamento = 0;
        let idMunicipio = 0;
        let nombreDepartamento = "";
        let nombreMunicipio = "";
        let nombreComunidad = "";
        let cenVotacion = "";
        let nombreOcupaciones = "";
        let position1 = "";
        let position2 = "";
        let position3 = "";
        let position4 = "";
        let description = [
            {name: "- Antes de continuar, revise que la información que ingresó esté correcta.",},
            {name: "- Datos requeridos (*)."}
        ]
        let bloquearCampos = false;
        let idDepartamentoResidencia='', idMunicipioResidencia=''; 
        let ArrayAlfabetismo =[ {id: 0, name: 'No lee, No Escribe'},{id: 1, name: 'Lee'},{id: 2, name: 'Escribe'},{id: 3, name: 'Lee, Escribe'}]
        let ArrayGenero =[ {id: 0, name: 'Femenino'}, {id: 1, name: 'Masculino'},]
        let ArrayNoVidentePadron =[ {id:0, name: 'Vidente'}, {id: 1, name: 'No vidente'}]
        let ArrayNoVidenteRenap =[ {id:'0', name: 'No Vidente'}, {id: '1', name: 'Vidente'}]        
        let idDepartamentoVecindad='', idDepartamentoNacimiento='', saveDataFormulario={};
        let isReturn = false;
    const CentroDeVotacionParseada = (numero, cantidad) =>{
        return (numero).toString().padStart(cantidad,'0')
    }        
    //consultar en el store por medio del iddepartamento si existe ya un municipio    
    const ObtenerMunicipiosEnMemoria = (municipio, departamento, idDepartamento) =>{
        let newElements= Object. assign({}, elements); 
        if(elements[departamento]?.value?.id === undefined){
            elements[municipio].list = [];
            elements[municipio].value =  null;
            return true;
        }
        const currentMunicipality = props.catalogos?.municipios?.filter( ({departamentoId}) => Number(departamentoId) === Number(idDepartamento));
        if(currentMunicipality?.length > 0) {
            newElements[municipio].list=currentMunicipality;
            setElements(newElements);
            setLoadingStateCity({loading: false, title:''})
            return true;
        } else return false;
    }            
    //cargamos los municipios en base al departamento seleccionado        
    //cargamos los departamentos
    let isFindState = false
    const setState =async ()=>{
        setLoadingStateCity({loading: true, title:'Cargando departamentos. Espere un momento ...'})
        let newElements= Object. assign({}, elements); 
        if((props.catalogos?.departamentoVecindad.length > 0)){
            newElements.departamentoVecindad.list = props.catalogos?.departamentoVecindad
            isFindState = true
        }
        if((props.catalogos?.departamentoNacimiento.length > 0)){
            newElements.departamentoNacimiento.list = props.catalogos?.departamentoNacimiento
            isFindState = true
        }
        if((props.catalogos?.departamentoResidencia.length > 0)){
            newElements.departamento.list = props.catalogos?.departamentoResidencia
            isFindState = true
        }

        if(isFindState){
            setLoadingStateCity({loading: false, title:''})
            setElements(newElements);
            return ;
        }

        try{
            let response = await ApiServices.departamentos.listRegisterCriteria();
            if(response.error){
            }else {  
                var datos = response.data
                Object.keys(datos).forEach((element, key, _array) =>{
                    if(datos[element].id !== "23" ){
                        newElements.departamentoVecindad.list.push({
                            id: datos[element].id,
                            name: datos[element].name,
                            municipios:[]
                        });
                    }

                    if(datos[element].id === "23" || datos[element].id === "24" || datos[element].id === "25"){
                    }else{
                        newElements.departamento.list.push({
                            id: datos[element].id,
                            name: datos[element].name,
                            municipios:[]
                        });                                
                    }

                    if(datos[element].id === "23" || datos[element].id === "25"){
                    }else{
                        newElements.departamentoNacimiento.list.push({
                            id: datos[element].id,
                            name: datos[element].name,
                            municipios:[]
                        });
                    }
                }) 
                props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DEPARTAMENTO_VECINDAD(newElements.departamentoVecindad.list)
                props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DEPARTAMENTO_NACIMIENTO(newElements.departamentoNacimiento.list)
                props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DEPARTAMENTO_RESIDENCIA(newElements.departamento.list)                
            } 
        }catch(exception){
            newElements.departamentoNacimiento.list=[];
        }
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);        
    };
    //cargamos los municipios en base al departamento seleccionado   
    let getDepartamentoResidencia = '', getMunicipioResidencia = ''         
    const setCity =async (event)=>{
        setLoadingStateCity({loading: true, title:'Cargando municipios de residencia. Espere un momento ...'})
        let newElements= Object. assign({}, elements); 
        if(event !== undefined) {
            if(event?.target?.value === "") {
                elements.municipio.list = [];
                elements.comunidad.list = [];                     
                elements.municipio.value = null;
                elements.comunidad.value = null                
                setLoadingStateCity({loading: false, title:''})
                return;
            }
            idDepartamentoResidencia = event.target.value;
            elements.municipio.value = null
            elements.comunidad.value = null   
            elements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
            elements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de Votación', value: ''}
            elements.comunidad.list = [];                     
            getDepartamentoResidencia = idDepartamentoResidencia
            isReturn = ObtenerMunicipiosEnMemoria('municipio', 'departamento', idDepartamentoResidencia)
        } else {
            if(!getDepartamentoResidencia){
                idDepartamentoResidencia = props.data.departamento.id
                isReturn = ObtenerMunicipiosEnMemoria('municipio', 'departamento', idDepartamentoResidencia)
            }else{
                isReturn = ObtenerMunicipiosEnMemoria('municipio', 'departamento', getDepartamentoResidencia)
            }
        } 
        if(isReturn){
            setLoadingStateCity({loading: false, title:''})
            return;
        }else{            
            try{
                ApiServices.municipios.searchCriteria.clear();
                ApiServices.municipios.searchCriteria.setOperator("and");
                ApiServices.municipios.searchCriteria.addEquals("departamentoId",idDepartamentoResidencia);
                ApiServices.municipios.setIsPublic(true);
                let response =await ApiServices.municipios.listRegisterCriteria();
                if(response.error){
                    newElements.municipio.list=[];
                    // setCargandoDatos(false);
                }else {                
                    if(props.catalogos?.municipios.length === 0 || elements.departamento.value != props.data.departamento){
                        elements.comunidad.value =  null
                        elements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
                        elements.comunidadCodigoGeoelectoral.value={title: 'Centro de Votación', value: ''}
                        elements.municipio.value = null
                    }else{
                        // newElements.municipio.list = props.ArrayListado.ArrayMunicipio
                    }                
                    props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_MUNICIPIOS(response.data)
                    newElements.municipio.list=response.data;
                }
            }catch(exception){
                newElements.municipio.list=[];
            }
        }
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };

    //cargamos los municipios en base al departamento Vecindad seleccionado       
    let getDepartamentoVecindad = ''; 
    const obtenerMuninipiosVecindad =async (event)=>{
        setLoadingStateCity({loading: true, title:'Cargando municipios de vecindad. Espere un momento ...'})
        let newElements= Object. assign({}, elements); 
        if(event !== undefined) {
            if(event?.target?.value === "") {
                elements.municipioVecindad.list = [];
                elements.municipioVecindad.value =  null;
                setLoadingStateCity({loading: false, title:''})
                return;
            }
            idDepartamentoVecindad = event.target.value;
            getDepartamentoVecindad = idDepartamentoVecindad
            elements.municipioVecindad.value =  null
            isReturn = ObtenerMunicipiosEnMemoria('municipioVecindad', 'departamentoVecindad', idDepartamentoVecindad)
        } else {
            if(!getDepartamentoVecindad){
                idDepartamentoVecindad = props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.departamentoVecindad?.id;                
                isReturn = ObtenerMunicipiosEnMemoria('municipioVecindad', 'departamentoVecindad', idDepartamentoVecindad)
            }else{
                isReturn = ObtenerMunicipiosEnMemoria('municipioVecindad', 'departamentoVecindad', getDepartamentoVecindad)
            }
        } 
        if(isReturn){
            setLoadingStateCity({loading: false, title:''})
            return;
        }else{
            try{
                ApiServices.municipios.searchCriteria.clear();
                ApiServices.municipios.searchCriteria.setOperator("and");
                ApiServices.municipios.searchCriteria.addEquals("departamentoId",idDepartamentoVecindad);
                ApiServices.municipios.setIsPublic(true);
                let response =await ApiServices.municipios.listRegisterCriteria();
                if(response.error){
                    newElements.municipioVecindad.list=[];
                }else {               
                        if(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.municipioVecindad) {
                            if(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.departamentoVecindad?.id != elements['departamentoVecindad'].value?.id) {
                                elements.municipioVecindad.value =  null;
                            }
                        } else {
                            elements.municipioVecindad.value =  null;
                        }                         
                        newElements.municipioVecindad.list=response.data;                        
                        props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_MUNICIPIOS(response.data)                        
                    }                    
            }catch(exception){
                elements.municipioVecindad.value =  null;
                newElements.municipioVecindad.list=[];
            }                    
        }
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };    
    //cargamos los municipios en base al departamento nacimiento seleccionado    
    let getDepartamentoNacimiento = ''        
    const obtenerMuninipiosNacimiento =async (event)=>{
        setLoadingStateCity({loading: true, title:'Cargando municipios de nacimiento. Espere un momento ...'})
        let newElements= Object. assign({}, elements); 
        if(event !== undefined) {
            if(event?.target?.value === "") {
                elements.municipioNacimiento.list = [];
                elements.municipioNacimiento.value =  null;
                setLoadingStateCity({loading: false, title:''})
                return;
            }
            idDepartamentoNacimiento = event.target.value;
            getDepartamentoNacimiento = idDepartamentoNacimiento
            elements.municipioNacimiento.value =  null
            isReturn = ObtenerMunicipiosEnMemoria('municipioNacimiento', 'departamentoNacimiento',  idDepartamentoNacimiento)
        } else {
            if(!getDepartamentoNacimiento){
                idDepartamentoNacimiento = props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.departamentoNacimiento?.id;
                isReturn = ObtenerMunicipiosEnMemoria('municipioNacimiento', 'departamentoNacimiento', idDepartamentoNacimiento)
            }else{
                isReturn = ObtenerMunicipiosEnMemoria('municipioNacimiento', 'departamentoNacimiento', getDepartamentoNacimiento)
            }
        } 
        if(isReturn){
            setLoadingStateCity({loading: false, title:''})
            return;
        }else{
            try{
                ApiServices.municipios.searchCriteria.clear();
                ApiServices.municipios.searchCriteria.setOperator("and");
                ApiServices.municipios.searchCriteria.addEquals("departamentoId",idDepartamentoNacimiento);
                ApiServices.municipios.setIsPublic(true);
                let response =await ApiServices.municipios.listRegisterCriteria();
                if(response.error){
                    newElements.municipioNacimiento.list=[];
                }else {               
                        if(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.municipioNacimieno) {
                            if(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.departamentoNacimiento?.id != elements['departamentoNacimiento'].value?.id) {
                                elements.municipioNacimiento.value =  null;
                            }
                        } else {
                            elements.municipioNacimiento.value =  null;
                        }                         
                        props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_MUNICIPIOS(response.data)                        
                        newElements.municipioNacimiento.list=response.data;                        
                    }  
            }catch(exception){
                elements.municipioNacimiento.value =  null;
                newElements.municipioNacimiento.list=[];
            }                    
        }
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };    
    //cargamos las comunidades en base al municipio seleccionado
    const ObtenerComunidadesEnMemoria = (idDepartamentoResidencia, idMunicipioResidencia) =>{
        let newElements= Object. assign({}, elements);
        let departamento = '', municipio = '';
        if(elements.departamento.value?.id === idDepartamentoResidencia && elements.municipio.value?.id === idMunicipioResidencia){
            departamento = idDepartamentoResidencia
            municipio = idMunicipioResidencia
        }else{            
            departamento = elements.departamento.value?.id
            municipio = elements.municipio.value?.id
        }
        const currentMunicipality = props.catalogos?.comunidades?.filter( ({departamentoId, municipioId}) => Number(departamentoId) === Number(departamento) && Number(municipioId) === Number(municipio));
        if(currentMunicipality?.length > 0) {
            newElements.comunidad.list=currentMunicipality;
            setElements(newElements);
            setLoadingStateCity({loading: false, title:''})
            return true;
        } else return false;
    }      
    const setComunidad =async (event)=>{
        setLoadingStateCity({loading: true, title:'Cargando comunidades. Espere un momento ...'})
        if(event === undefined) idMunicipio = props.data.municipio.id;
        else {
            idMunicipio = event.target.value;
            elements.comunidad.value =  null
            elements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
            elements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de Votación', value: ''}
        }

        let newElements= Object. assign({}, elements); 
        if((elements.municipio.value?.id === "" || elements.municipio.value?.id === 0 || elements.municipio.value?.id === undefined)){
            elements.comunidad.list=[];
            setLoadingStateCity({loading: false, title:''})
            return;
        }
        if((elements.departamento.value?.id !== "" && elements.municipio.value?.id !== "")){
            isReturn = ObtenerComunidadesEnMemoria(idDepartamentoResidencia, idMunicipio)
            if(isReturn){
                setLoadingStateCity({loading: false, title:''})
                return;
            }else{                
                try{
                    ApiServices.comunidades.searchCriteria.clear();
                    ApiServices.comunidades.searchCriteria.setOperator("and");
                    ApiServices.comunidades.searchCriteria.addEquals("departamentoId", idDepartamentoResidencia);
                    ApiServices.comunidades.searchCriteria.addEquals("municipioId",idMunicipio);
                    let response =await ApiServices.comunidades.listRegisterCriteria();
                    if(response.error){
                        newElements.comunidad.list=[];
                    }else {                
                        // if(props.ArrayListado.ArrayComunidad.length === 0 || elements.municipio.value != props.data.municipio){
                        //     elements.comunidad.value =  null
                        //     newElements.comunidad.list=response.data;
                        // }else{
                            //     newElements.comunidad.list = props.ArrayListado.ArrayComunidad
                            // }                
                        props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_COMUNIDAD(response.data)
                        newElements.comunidad.list=response.data;
                    }
                }catch(exception){
                    newElements.comunidad.list=[];
                    elements.comunidad.value =  null
                    elements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
                    elements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de votación', value: ''}
                }
            }
        }
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };
    //cargamos las ocupaciones
    const setOcupaciones =async ()=>{
        setLoadingStateCity({loading: true, title:'Cargando profesiones. Espere un momento ...'})
        let newElements= Object. assign({}, elements); 
        if(props.catalogos.ocupaciones.length === 0){
            try{
                let response = await ApiServices.ocupaciones.listRegisterCriteria();
                newElements.profesion.list=[];
                if(response.error){
                }else {
                    var datos = response.data
                    Object.keys(datos).forEach((element, key, _array) =>{
                        if(datos[element].name !== " "){
                            newElements.profesion.list.push({
                                id: datos[element].id,
                                name: datos[element].name,
                            });
                        }
                    })
                    props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_OCUPACIONES(newElements.profesion.list)
                } 
            }catch(exception){
                newElements.profesion.list=[];
            }
        }else{
            newElements.profesion.list = props.catalogos?.ocupaciones
        }
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };          
    const esAnalfabeta = (event) =>{
        setAnalfabeta(event.target.value)
    }
    const esNoVidente = (event) =>{
        setNovidente(event.target.value)
    }
    const ObtenerCodigoGeolectoralSeleccionado = (comunidad) =>{
        var datos = elements.comunidad.list, centroDeVotacion='';
        let newElements= Object. assign({}, elements); 

        Object.keys(datos).forEach((element, key, _array) =>{
            if(datos[element].id === comunidad?.target?.value){
                centroDeVotacion = datos[element].centroVotacionId
                newElements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: CentroDeVotacionParseada(comunidad?.target?.value, 4)}
                newElements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de Votación', value: CentroDeVotacionParseada(centroDeVotacion, 4)}
                setElements(newElements);              
            }
        })
        if(newElements.comunidad.value?.id === undefined || newElements.comunidad.value?.id === 0) {
            newElements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
            newElements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de votación', value: ''}
            setElements(newElements);              
        }                
    }
    // obtener catalogo de paises
    let paisSeleccionado = ''; let estadoDelPaisSeleccionado = '';
    const obtenerPaises =async ()=>{
        setLoadingStateCity({loading: true, title:'Cargando catálogo de paises ...'})
        let newElements= Object.assign({}, elements);
        if(elements.paisResidenciaElectoral.value === null){
            paisSeleccionado = ''
            estadoDelPaisSeleccionado = ''
            newElements.estadoResidenciaElectoral.value =  null;
            newElements.ciudadResidenciaElectoral.value =  null;
            newElements.ciudadResidenciaElectoral.list =  []
            newElements.estadoResidenciaElectoral.list=[];            
        }

        if(newElements.paisResidenciaElectoral.list.length === 0){
            try{
                let response = await ApiServices.paises.listRegisterCriteria();
                if(response.error){
                    showMessagePersonalizedPosition('warning','¡Advertencia!', response?.error?.message,'center')
                }else {
                    const newData = response?.data.filter( item => item.id !== 1);
                    newElements.paisResidenciaElectoral.list = newData
                } 
            }catch(exception){
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
        }
        setElements(newElements);
        setLoadingStateCity({loading: false, title:''})
    };
    //obtener catalogo de estados del pais
    const obtenerEstadoDelPais =async (event)=>{
        let newElements= Object. assign({}, elements);
        paisSeleccionado = event.target.value
        setLoadingStateCity({loading: true, title:'Cargando catálogo de estados ...'})
        if(newElements.estadoResidenciaElectoral.list.length === 0){
            try{
                ApiServices.estadosDePaises.searchCriteria.clear();
                ApiServices.estadosDePaises.searchCriteria.setOperator("and");
                ApiServices.estadosDePaises.searchCriteria.addEquals("paisId",paisSeleccionado);
                ApiServices.estadosDePaises.setIsPublic(true);
                let response =await ApiServices.estadosDePaises.listRegisterCriteria();
    
                if(response.error){
                    showMessagePersonalizedPosition('warning','¡Advertencia!', response?.error?.message,'center')
                    newElements.estadoResidenciaElectoral.list=[];
                }else {                
                    newElements.estadoResidenciaElectoral.list=response.data;
                    newElements.ciudadResidenciaElectoral.value =  null;
                    newElements.ciudadResidenciaElectoral.list =  []
                }
            }catch(exception){
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                newElements.estadoResidenciaElectoral.value =  null;
                newElements.ciudadResidenciaElectoral.value =  null;
                newElements.ciudadResidenciaElectoral.list =  []
                newElements.estadoResidenciaElectoral.list=[];
            }
            
        }                   
        setElements(newElements);
        setLoadingStateCity({loading: false, title:''})
    };    
    //obtener catalogo de ciudades
    const obtenerCiudadDelEstadoDelPais =async (event)=>{
        let newElements= Object. assign({}, elements); 
        estadoDelPaisSeleccionado = event.target.value
        setLoadingStateCity({loading: true, title:'Cargando catálogo de ciudades ...'})
        if((paisSeleccionado !== "" && estadoDelPaisSeleccionado !== "")){
            if(elements.estadoResidenciaElectoral.value !== null){
                try{
                    ApiServices.ciudades.searchCriteria.clear();
                    ApiServices.ciudades.orderCriteria.clear();
                    ApiServices.ciudades.searchCriteria.setOperator("and");
                    ApiServices.ciudades.searchCriteria.addEquals("paisId", paisSeleccionado);
                    ApiServices.ciudades.searchCriteria.addEquals("estadoId",estadoDelPaisSeleccionado);
                    ApiServices.ciudades.orderCriteria.addAsc("id");
                    let response =await ApiServices.ciudades.listRegisterCriteria();
                    if(response.error){
                        showMessagePersonalizedPosition('warning','¡Advertencia!', response?.error?.message,'center')
                        newElements.ciudadResidenciaElectoral.list=[];
                    }else {               
                        newElements.ciudadResidenciaElectoral.list=response.data;                   
                    }
                }catch(exception){
                    showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
            }
        }else{
            elements.ciudadResidenciaElectoral.value =  null;
            elements.ciudadResidenciaElectoral.list =  [];
        }
        setLoadingStateCity({loading: false, title:''})
        setElements(newElements);
    };    

    const [elements,setElements] = useState({
        datosDPI:{
            idelement: "datosDPI", title:'DATOS DEL DPI', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom', show: true,
        },
            cui: { autofocus: true,
                idelement: "cui", value:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.cui, label: "Número de CUI *", pattern:"^[0-9]*$", validators: ['required'], 
                errorMessages:['CUI requerido, máximo 13 carácteres'], isError:false, elementType:'input' , type: 'number', initialRequiredLength:1, finalRequiredLength: 13,
                disabled: true, currentValue:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.cui
            },
            serie: {
                idelement: "serie", value:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.serieDPI, label: "Número de Serie *", pattern:"^[0-9]*$", validators: ['required'], 
                errorMessages:['Serie requerido, máximo 13 carácteres'], isError:false, elementType:'inputCustom' , type: 'number', initialRequiredLength:1, finalRequiredLength: 13,
                disabled: true, currentValue:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.serieDPI,
            },
            fechaEmisionDPI: {
                idelement: "fechaEmisionDPI", value:new Date(props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.fechaEmisionDPI), label: "Fecha de Emisión *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", 
                validators: ['required'], errorMessages:['fecha dd/MM/yyyy'], isError:false, elementType:'date' , modified: true,
                disabled: true, currentValue:new Date(props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.fechaEmisionDPI)
            },
            departamentoVecindad: {
                idelement: "departamentoVecindad", value:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.departamentoVecindad, label: "Departamento Vecindad *", pattern:"^[1-9][0-9]*$", validators: ['required'],
                errorMessages:['Seleccione el Departamento Vecindad DPI'], isError:false, elementType:'autocompleteV2', list: [],
                disabled: true, modified: true, currentValue:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.departamentoVecindad, 
                handler: obtenerMuninipiosVecindad, focus: {ejecutar: true, function: setState},
                
            },
            municipioVecindad: {
                idelement: "municipioVecindad", value: municipioVecindadActual, label: "Municipio Vecindad *", pattern:"^[1-9][0-9]*$", validators: ['required'], 
                errorMessages:['Seleccione el Municipio Vecindad DPI'], isError:false, elementType:'autocompleteV2', list: [], 
                disabled: true, modified: true,
                currentValue: municipioVecindadActual, focus: {ejecutar: true, function: obtenerMuninipiosVecindad}
            },     
        datosCiudadano:{
            idelement: "datosCiudadano",title:'DATOS DEL CIUDADANO', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom', show: true,
        },
            primerNombre: { 
                idelement: "primerNombre",  value:props.datosCiudadanoTable?.primerNombre ||'', label: "Primer Nombre Ciudadano (a) *", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$",
                validators: ['required'], errorMessages:['Requerido, máximo 30 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', initialRequiredLength:1, finalRequiredLength: 30,
                disabled: true, currentValue:props.datosCiudadanoTable?.primerNombre,
            },        
            segundoNombre: { 
                idelement: "segundoNombre",  value: props.datosCiudadanoTable?.segundoNombre ? props.datosCiudadanoTable?.segundoNombre: '',
                label: "Segundo Nombre Ciudadano (a)", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
                validators: ['requireds'], errorMessages:['Máximo 30 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
                disabled: true, currentValue:props.datosCiudadanoTable?.segundoNombre ? props.datosCiudadanoTable?.segundoNombre: '', initialRequiredLength:0, finalRequiredLength: 30,
            },        
            primerApellido: { 
                idelement: "primerApellido",  value:props.datosCiudadanoTable?.primerApellido ? props.datosCiudadanoTable?.primerApellido:'', label: "Primer Apellido Ciudadano (a) *", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
                validators: ['required'], errorMessages:['Requerido, máximo 30 carácteres sin espacios al inicio y final'], isError:false, elementType:'inputCustom', isRegex: true,
                disabled: true, currentValue:props.datosCiudadanoTable?.primerApellido ? props.datosCiudadanoTable?.primerApellido:'', initialRequiredLength:1, finalRequiredLength: 30,
            },        
            segundoApellido: { 
                idelement: "segundoApellido",  value:props.datosCiudadanoTable?.segundoApellido ? props.datosCiudadanoTable?.segundoApellido:'', label: "Segundo Apellido Ciudadano (a)", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
                validators: ['requireds'], errorMessages:['Máximo 30 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
                disabled: true, currentValue:props.datosCiudadanoTable?.segundoApellido ? props.datosCiudadanoTable?.segundoApellido:'', initialRequiredLength:0, finalRequiredLength: 30,
            },        
            tercerApellido: { 
                idelement: "tercerApellido",  value:props.datosCiudadanoTable?.tercerApellido ? props.datosCiudadanoTable?.tercerApellido:'', label: "Apellido de Casada", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
                validators: ['requireds'], errorMessages:['Máximo 30 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
                disabled: true, currentValue:props.datosCiudadanoTable?.tercerApellido ? props.datosCiudadanoTable?.tercerApellido:'', initialRequiredLength:0, finalRequiredLength: 30,
            },        
            genero: {
                idelement: "genero", value: props.datosCiudadanoTable?.genero||'', label: "Género *", pattern:"^([0-9][0-9]*){1,1}$", validators: ['required'], 
                errorMessages:['Seleccione Género'], isError:false, elementType:'autocompleteV2', list: ArrayGenero,
                disabled: true, modified: true, currentValue: props.datosCiudadanoTable?.genero,
            },        
            alfabetismo: {
                idelement: "alfabetismo", value:props.datosCiudadanoTable?.alfabetismo||'', label: "Alfabetismo *", pattern:"^([0-9][0-9]*){1,1}$", validators: ['required'], 
                errorMessages:['Seleccione una opción'], isError:false, elementType:'autocompleteV2', list: ArrayAlfabetismo, 
                handler: esAnalfabeta, disabled: true, modified: true, currentValue:props.datosCiudadanoTable?.alfabetismo,
            },        
            noVidente: {
                idelement: "noVidente", value:props.datosCiudadanoTable?.noVidente||'', label: "Vista *", pattern:"^([0-9][0-9]*){1,1}$", validators: ['required'], 
                errorMessages:['Seleccione una opción'], isError:false, elementType:'autocompleteV2', list: ArrayNoVidentePadron, 
                handler: esNoVidente, disabled: true, modified: true, currentValue:props.datosCiudadanoTable?.noVidente,
            },        
            fechaNacimiento: {
                idelement: "fechaNacimiento", value:new Date(props.datosCiudadanoTable?.fechaNacimiento), label: "Fecha de Nacimiento *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", 
                validators: ['required'], errorMessages:['fecha dd/MM/yyyy'], isError:false, elementType:'date' , modified: true,
                disabled: true, currentValue:new Date(props.datosCiudadanoTable?.fechaNacimiento)
            },
            paisNacimiento: {
                idelement: "paisNacimiento", value:'', label: "Pais Nacimiento *", pattern:"^[1-9][0-9]*$", validators: ['required'], 
                errorMessages:['Seleccione el Departamento'], isError:false, elementType:'autocompleteV2', list: [],
                disabled: true, modified: false, currentValue:''
            },
            departamentoNacimiento: {
                idelement: "departamentoNacimiento", value:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.departamentoNacimiento, label: "Departamento Nacimiento *", pattern:"^[1-9][0-9]*$", validators: ['required'], 
                errorMessages:['Seleccione el Departamento'], isError:false, elementType:'autocompleteV2', list: [], focus: {ejecutar: true, function: setState},
                disabled: true, modified: true, currentValue:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.departamentoNacimiento, handler: obtenerMuninipiosNacimiento
            },
            municipioNacimiento: {
                idelement: "municipioNacimiento", value:(municipioNacimientoActual?.id === undefined || municipioNacimientoActual?.id === null) ? null:municipioNacimientoActual, label: "Municipio Nacimiento *", pattern:"^^[1-9][0-9]*$", validators: ['required'], 
                errorMessages:['Seleccione el Municipio'], isError:false, elementType:'autocompleteV2', list: [],  focus: {ejecutar: true, function: obtenerMuninipiosNacimiento},
                disabled: true, modified: true, currentValue:(municipioNacimientoActual?.id === undefined || municipioNacimientoActual?.id === null) ? null:municipioNacimientoActual,
            },
            nroLibroNacimiento: {
                idelement: "nroLibroNacimiento", value:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.numeroLibroNacimientoDPI||'', label: "Libro", pattern:"", 
                validators: ['requireds'], errorMessages:['Máximo 10 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom' ,
                disabled: true, currentValue:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.numeroLibroNacimientoDPI||'', initialRequiredLength: 0, finalRequiredLength: 20,
            },    
            nroFolioNacimiento: {
                idelement: "nroFolioNacimiento", value:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.numeroFolioNacimientoDPI||'', label: "Folio", pattern:"", 
                validators: ['requireds'], errorMessages:['Máximo 10 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom' ,
                disabled: true, currentValue:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.numeroFolioNacimientoDPI||'', initialRequiredLength: 0, finalRequiredLength: 20,
            },    
            nroPartidaNacimiento: {
                idelement: "nroPartidaNacimiento", value:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.numeroPartidaNacimientoDPI||'', label: "Partida", pattern:"", 
                validators: ['requireds'], errorMessages:['Máximo 10 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom' ,
                disabled: true, currentValue:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.numeroPartidaNacimientoDPI||'', initialRequiredLength: 0, finalRequiredLength: 20,
            },                                        
            telefono: {
                idelement: "telefono", value:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.telefono||'', label: "Teléfono", pattern:"^([+0-9_][0-9_ -.\"\']*[0-9_.\"\']){0,34}$", 
                validators: ['requireds'], errorMessages:['Máximo 30 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom',
                currentValue:props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.telefono||'', disabled:true, initialRequiredLength: 0, finalRequiredLength: 30
            },                                        
            primerNombrePadre: { 
                idelement: "primerNombrePadre",  value:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerNombrePadre||'', label: "Primer Nombre Padre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$",
                validators: ['requireds'], errorMessages:['Máximo 30 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
                disabled: true, currentValue: props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerNombrePadre||'', initialRequiredLength: 0, finalRequiredLength: 30,
            },        
            segundoNombrePadre: { 
                idelement: "segundoNombrePadre",  value:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoNombrePadre||'', label: "Segundo Nombre Padre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
                validators: ['requireds'], errorMessages:['Máximo 30 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
                disabled: true, currentValue: props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoNombrePadre||'', initialRequiredLength: 0, finalRequiredLength: 30,
            },        
            primerApellidoPadre: { 
                idelement: "primerApellidoPadre",  value:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerApellidoPadre||'', label: "Primer Apellido Padre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
                validators: ['requireds'], errorMessages:['Máximo 30 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
                disabled: true, currentValue:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerApellidoPadre||'', initialRequiredLength: 0, finalRequiredLength: 30,
            },        
            segundoApellidoPadre: { 
                idelement: "segundoApellidoPadre",  value:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoApellidoPadre||'', label: "Segundo Apellido Padre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
                validators: ['requireds'], errorMessages:['Máximo 30 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
                disabled: true, currentValue:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoApellidoPadre||'', initialRequiredLength: 0, finalRequiredLength: 30,
            },        
            primerNombreMadre: { 
                idelement: "primerNombreMadre",  value:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerNombreMadre||'', label: "Primer Nombre Madre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
                validators: ['requireds'], errorMessages:['Máximo 30 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
                disabled: true, currentValue:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerNombreMadre||'', initialRequiredLength: 0, finalRequiredLength: 30,
            },        
            segundoNombreMadre: { 
                idelement: "segundoNombreMadre",  value:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoNombreMadre||'', label: "Segundo Nombre Madre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
                validators: ['requireds'], errorMessages:['Máximo 30 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
                disabled: true, currentValue:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoNombreMadre||'', initialRequiredLength:0, finalRequiredLength: 30,
            },        
            primerApellidoMadre: { 
                idelement: "primerApellidoMadre",  value:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerApellidoMadre||'', label: "Primer Apellido Madre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
                validators: ['requireds'], errorMessages:['Máximo 30 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
                disabled: true, currentValue:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.primerApellidoMadre||'', initialRequiredLength: 0, finalRequiredLength: 30,
            },        
            segundoApellidoMadre: { 
                idelement: "segundoApellidoMadre",  value:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoApellidoMadre||'', label: "Segundo Apellido Madre", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
                validators: ['requireds'], errorMessages:['Máximo 30 carácteres, sin espacios al inicio y final'], isError:false, elementType:'inputCustom', 
                disabled: true, currentValue:props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.segundoApellidoMadre||'', initialRequiredLength: 0, finalRequiredLength: 30,
            },        
        direccionRenap:{
            idelement: "direccionRenap", title:'Dirección de Residencia de Referencia de RENAP', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom',
            backgroundColor:'#1C4E78', color: "white", fontSize: '17px', show: true,
        },              
            direccionResidenciaRENAP:{
                idelement: "direccionResidenciaRENAP", position:"center",  isError:false, elementType:'labelCustomV2',
                value: 'Dirección Residencia RENAP: ' + (props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.direccionElectoral ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.direccionElectoral :''),
                currentValue: 'Dirección Residencia RENAP: ' + (props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.direccionElectoral ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.direccionElectoral :''),
                colorChip:'#1C4E78', letraColorChip: "white", show: true,
            },        
            noCasaLoteResidenciaRENAP:{
                idelement: "noCasaLoteResidenciaRENAP", position:"center",  isError:false, elementType:'labelCustomV2',
                value: 'No. Casa/Lote Residencia RENAP: ' + (props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.nroCasaElectoral ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.nroCasaElectoral :''), 
                currentValue: 'No. Casa/Lote Residencia RENAP: ' + (props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.nroCasaElectoral ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.nroCasaElectoral :''), 
                colorChip:'#1C4E78', letraColorChip: "white", show: true,
            },        
            zonaResidenciaRENAP:{
                idelement: "zonaResidenciaRENAP", position:"center",  isError:false, elementType:'labelCustomV2',
                value: 'Zona Residencia RENAP: ' + (props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.nroZonaElectoral ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.nroZonaElectoral :''), 
                currentValue: 'Zona Residencia RENAP: ' + (props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.nroZonaElectoral ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.nroZonaElectoral :''), 
                colorChip:'#1C4E78', letraColorChip: "white", show: true,
            },                
            departamentoResidenciaRENAP:{
                idelement: "departamentoResidenciaRENAP", position:"center",  isError:false, elementType:'labelCustomV2',
                value: 'Departamento Residencia RENAP: ' + (props.datosCiudadanoTable?.departamentoResidencia ? props.datosCiudadanoTable?.departamentoResidencia?.name :''), 
                currentValue: 'Departamento Residencia RENAP: ' + (props.datosCiudadanoTable?.departamentoResidencia ? props.datosCiudadanoTable?.departamentoResidencia?.name :''), 
                colorChip:'#1C4E78', letraColorChip: "white", show: true,
            },        
            municipioResidenciaRENAP:{
                idelement: "municipioResidenciaRENAP", position:"center",  isError:false, elementType:'labelCustomV2',
                value: 'Municipio Residencia RENAP: ' + (props.datosCiudadanoTable?.municipioResidencia ? props.datosCiudadanoTable?.municipioResidencia?.name :''), 
                currentValue: 'Municipio Residencia RENAP: ' + (props.datosCiudadanoTable?.municipioResidencia ? props.datosCiudadanoTable?.municipioResidencia?.name :''), 
                colorChip:'#1C4E78', letraColorChip: "white", show: true,
            },
            titleProfesion:{
                idelement: "titleProfesion", title:'Profesión u Oficio', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom',
                backgroundColor:'#1C4E78', color: "white", fontSize: '17px', show: true,
            },                
                profesionRenap:{
                    idelement: "profesionRenap", position:"center",  isError:false, elementType:'labelCustom', 
                    value: 'Profesión: ' + (props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.descripcionOcupacion ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.descripcionOcupacion :''), 
                    currentValue: 'Profesión: ' + (props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.descripcionOcupacion ? props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.descripcionOcupacion :''), 
                    show: true,
                },        
        residenciaElectoralActualEnElPadron:{
            idelement: "residenciaElectoralActualEnElPadron", title:'RESIDENCIA ELECTORAL ACTUAL EN EL PADRON', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom',
            show: true,
        },       
            direccionResidenciaActualEnElPadron:{
                idelement: "direccionResidenciaActualEnElPadron", position:"center",  isError:false, elementType:'labelCustom',
                value: '', currentValue:"", 
            },                        
            noCasaLoteResidenciaActualEnElPadron:{
                idelement: "noCasaLoteResidenciaActualEnElPadron", position:"center",  isError:false, elementType:'labelCustom',
                value: '', currentValue:"", 
            },                        
            zonaResidenciaActualEnElPadron:{
                idelement: "zonaResidenciaActualEnElPadron", position:"center",  isError:false, elementType:'labelCustom',
                value: '', currentValue:"", 
            },                        
            departamentoResidenciaActualEnElPadron:{
                idelement: "departamentoResidenciaActualEnElPadron", position:"center",  isError:false, elementType:'labelCustom',
                value: '', currentValue:"", 
            },                        
            municipioResidenciaActualEnElPadron:{
                idelement: "municipioResidenciaActualEnElPadron", position:"center",  isError:false, elementType:'labelCustom',
                value: '', currentValue:"", 
            },                        
            comunidadResidenciaActualEnElPadron:{
                idelement: "comunidadResidenciaActualEnElPadron", position:"center",  isError:false, elementType:'labelCustom',
                value: '', currentValue:"", 
            },                        
        residenciaRenapExtranjero:{
            idelement: "residenciaRenapExtranjero", title:'RESIDENCIA RENAP DEL EXTRANJERO', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom',
            show: (props.datosCiudadanoTable?.departamentoResidencia?.id === 25 && props.datosCiudadanoTable?.municipioResidencia?.id?.id === 1) ? true : false,
        },
            idSolicitudResidenciaRenapExtranjero:{
                idelement: "idSolicitudResidenciaRenapExtranjero", position:"center",  isError:false, elementType:'labelCustomV2',
                value: ('Solicitud No.: '+(props.datosResidenciaExtranjeroRenapSeleccionado?.idSolicitud || '')), currentValue:"", 
                show: (props.datosCiudadanoTable?.departamentoResidencia?.id === 25 && props.datosCiudadanoTable?.municipioResidencia?.id?.id === 1) ? true : false,
            },                        
            cuiResidenciaRenapExtranjero:{
                idelement: "cuiResidenciaRenapExtranjero", position:"center",  isError:false, elementType:'labelCustomV2',
                value: ('CUI: '+(props.datosResidenciaExtranjeroRenapSeleccionado?.cui || '')), currentValue:"", 
                show: (props.datosCiudadanoTable?.departamentoResidencia?.id === 25 && props.datosCiudadanoTable?.municipioResidencia?.id?.id === 1) ? true : false,
            },                        
            paisResidenciaRenapExtranjero:{
                idelement: "paisResidenciaRenapExtranjero", position:"center",  isError:false, elementType:'labelCustomV2',
                value: ('País: '+(props.datosResidenciaExtranjeroRenapSeleccionado?.paisResidencia?.name || '')), currentValue:"", 
                show: (props.datosCiudadanoTable?.departamentoResidencia?.id === 25 && props.datosCiudadanoTable?.municipioResidencia?.id?.id === 1) ? true : false,
            },                        
            estadoResidenciaRenapExtranjero:{
                idelement: "estadoResidenciaRenapExtranjero", position:"center",  isError:false, elementType:'labelCustomV2',
                value: ('Estado: '+(props.datosResidenciaExtranjeroRenapSeleccionado?.estadoResidencia?.name || '')), currentValue:"", 
                show: (props.datosCiudadanoTable?.departamentoResidencia?.id === 25 && props.datosCiudadanoTable?.municipioResidencia?.id?.id === 1) ? true : false,
            },                        
            ciudadResidenciaRenapExtranjero:{
                idelement: "ciudadResidenciaRenapExtranjero", position:"center",  isError:false, elementType:'labelCustomV2',
                value: ('Ciudad: '+(props.datosResidenciaExtranjeroRenapSeleccionado?.ciudadResidencia?.name || '')), currentValue:"", 
                show: (props.datosCiudadanoTable?.departamentoResidencia?.id === 25 && props.datosCiudadanoTable?.municipioResidencia?.id?.id === 1) ? true : false,
            },         
        direccionRenapExtranjero:{
            idelement: "direccionRenapExtranjero", title:'DIRECCIÓN DE RESIDENCIA DPI', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom',
            show: (props.datosCiudadanoTable?.departamentoResidencia?.id === 25 && props.datosCiudadanoTable?.municipioResidencia?.id?.id === 1) ? true : false,
        },
            valorDeDireccionRenapExtranjero:{
                idelement: "valorDeDireccionRenapExtranjero", position:"center",  isError:false, elementType:'labelCustomV2',
                value: ((props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.complementoDpiSolicitud?.direccionRenap || '')), currentValue:"", 
                show: (props.datosCiudadanoTable?.departamentoResidencia?.id === 25 && props.datosCiudadanoTable?.municipioResidencia?.id?.id === 1) ? true : false,
            },        
        asignarResidenciaElectoral:{
            idelement: "asignarResidenciaElectoral", title:'Asignar Residencia Electoral', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom',
            show: true,
        },              
            direccion: { 
                idelement: "direccion",  value:props.data?.direccion, label: "Dirección*", pattern:"^([\\w1-9_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-][\\w1-9_ ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-]*[\\w1-9_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜ.,!¡\"#$%&/()=¿?'@*-])$", 
                validators: ['required'], errorMessages:['Requerido, Máximo 50 carácteres, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true, initialRequiredLength:2, finalRequiredLength: 50
            },
            nocasalote: {  
                idelement: "nocasalote",  value:props.data?.nocasalote, label: "No. Casa/Lote", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()])$", 
                validators: ['requireds'], initialRequiredLength: 0, finalRequiredLength: 10,
                errorMessages:['No. Casa/Lote - Máximo 10 carácteres, sin espacios al inicio y final'], isError:false, elementType:'input',
            },
            zona: {  
                idelement: "zona",  value: props.data?.zona, label: "Zona", pattern:"^[0-9]*$", validators: ['requireds'], errorMessages:['Zona - Máximo 2 carácteres, sin espacios al inicio y final'], 
                isError:false, elementType:'input', initialRequiredLength: 0, finalRequiredLength: 2,
            },

            paisResidenciaElectoral: {  
                idelement: "paisResidenciaElectoral",  value: null, label: "Seleccione país *", pattern:"^[1-9][0-9]*$", validators: ['required'], focus: {ejecutar: true, function: obtenerPaises},
                errorMessages:['País requerido'], isError:false, elementType:'autocompleteV2', list: [], handler: obtenerEstadoDelPais,
            },
            estadoResidenciaElectoral: {  
                idelement: "estadoResidenciaElectoral",  value: null, label: "Seleccione estado *", pattern:"^[1-9][0-9]*$", validators: ['required'], 
                errorMessages:['Estado requerido'], isError:false, elementType:'autocompleteV2', list: [], handler: obtenerCiudadDelEstadoDelPais,
            },
            ciudadResidenciaElectoral: {
                idelement: "ciudadResidenciaElectoral",  value: null, label: "Seleccione ciudad *", pattern:"^[1-9][0-9]*$", validators: ['required'],
                errorMessages:['Ciudad requerida'], isError:false, elementType:'autocompleteV2', list: []
            },
            // departamento: {  idelement: "departamento",  value: props.data.departamento, label: "Departamento", pattern:"^[1-9][0-9]*$", validators: ['required'], errorMessages:['Departamento requerido'], isError:false, elementType:'dropdown', list: [], handler: setCity},
            departamento: {  
                idelement: "departamento",  value: props.data?.departamento || null, label: "Departamento*", pattern:"^[1-9][0-9]*$", validators: ['required'], focus: {ejecutar: true, function: setState},
                errorMessages:['Departamento requerido'], isError:false, elementType:'autocompleteV2', list: [], handler: setCity, position:props.datosResidencia.position1,
                // showSelectAutoComplete: false,
            },
            // municipio: {  idelement: "municipio",  value: props.data.municipio, label: "Municipio", pattern:"^[1-9][0-9]*$", validators: ['required'], errorMessages:['Municipio requerido'], isError:false, elementType:'dropdown', list: [], handler: setComunidad},
            municipio: {  
                idelement: "municipio",  value: props.data?.municipio || null, label: "Municipio*", pattern:"^[1-9][0-9]*$", validators: ['required'], 
                errorMessages:['Municipio requerido'], isError:false, elementType:'autocompleteV2', list: [], handler: setComunidad, position:props.datosResidencia.position2,
                // focus: {ejecutar: true, function: setCity}, showSelectAutoComplete: false,
            },
            // comunidad: {  idelement: "comunidad",  value: props.data.comunidad, label: "Comunidad", pattern:"^[\\w\\s]{1,}$", validators: ['required'], errorMessages:['Comunidad requerida'], isError:false, elementType:'dropdown', list: [] },
            comunidad: {  
                idelement: "comunidad",  value: props.data?.comunidad || null, label: "Comunidad*", pattern:"^[1-9][0-9]*$", validators: ['required'], handler: ObtenerCodigoGeolectoralSeleccionado,
                errorMessages:['Comunidad requerida'], isError:false, elementType:'autocompleteV2', list: [], position:props.datosResidencia.position3, focus: {ejecutar: true, function: setComunidad},
                // showSelectAutoComplete: false,
            },
            profesion: {  
                idelement: "profesion",  value:props.data?.profesion || null, label: "Profesión u Oficio*", pattern:"^[\\w\\s-,]{1,}$", validators: ['required'], focus: {ejecutar: true, function: setOcupaciones},
                errorMessages:['Profesión u Oficio requerido'], isError:false, elementType:'autocompleteV2', list: [], position:props.datosResidencia.position4,
            },
            // profesion: {  idelement: "profesion",  value:props.data.profesion, label: "Profesión u Oficio", pattern:"^[\\w\\s-,]{1,}$", validators: ['required'], errorMessages:['Profesión u Oficio requerido'], isError:false, elementType:'dropdown', list: [] },
            email: {    
                idelement: "email", value: props.data?.email || props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.email||'', label: "Correo", 
                pattern:"^([\\wA-Z0-9._%+-]+@[\\wA-Z0-9.-]+\\.\\w{2,3})$", validators: ['requireds'],  errorMessages:['Máximo 125 carácteres, sin espacios al inicio y final'], isError:false, elementType:'input', initialRequiredLength: 0, finalRequiredLength: 125
            },        
        codigoGeoelectoral:{
            idelement: "codigoGeoelectoral", title:'Código GeoElectoral', position:"center", value: "", currentValue:"", isError:false, elementType:'titleCustom', show: true,
        },
            departamentoCodigoGeoelectoral:{
                idelement: "departamentoCodigoGeoelectoral", position:"center",  isError:false, elementType:'labelWithTitleAndSubtitle',
                value: {title: 'Departamento', value:''}, currentValue:"", show: true,
            },
            municipioCodigoGeoelectoral:{
                idelement: "municipioCodigoGeoelectoral", position:"center",  isError:false, elementType:'labelWithTitleAndSubtitle',
                value: {title: 'Municipio', value:''}, currentValue:"", show: true,
            },
            comunidadCodigoGeoelectoral:{
                idelement: "comunidadCodigoGeoelectoral", position:"center",  isError:false, elementType:'labelWithTitleAndSubtitle',
                value: {title: 'Comunidad', value:''}, currentValue:"", show: true,
            },
            centroVotacionCodigoGeoelectoral:{
                idelement: "centroVotacionCodigoGeoelectoral", position:"center",  isError:false, elementType:'labelWithTitleAndSubtitle',
                value: {title: 'Centro de Votación', value:''}, currentValue:"", show: true,
            },
            // titleObservacion:{
            //     idelement: "titleObservacion",title:'Observaciones', position:"center", value: "", isError:false, elementType:'title'
            // },    
            // observaciones: {
            //     idelement: "observaciones",  value:props.data.observaciones, label: "Observación", pattern:"^[\\w1-9 _Ññ.,!¡\"#$%&/()=¿?'@*-]{0,1024}$", minWidth: 1000,
            //     validators: ['required'], errorMessages:['Máximo 50 carácteres'], isError:false, elementType:'input', showInputControl: true,
            // },
    });
    const ObtenerNombreComunidad = () =>{
        var datos = [];
        const currentMunicipality = props.catalogos?.comunidades?.filter( ({departamentoId, municipioId}) => Number(departamentoId) === Number(elements.departamento.value?.id) && Number(municipioId) === Number(elements.municipio.value?.id));
        if(currentMunicipality?.length > 0) {
            datos =currentMunicipality;
            Object.keys(datos).forEach((element, key, _array) =>{
                if(datos[element].id === elements.comunidad.value.id){
                    nombreComunidad = datos[element].name
                    cenVotacion = datos[element].centroVotacionId
                    position3 = element
                }
            }) 
        }
    }
    const ObtenerNombreOcupaciones = () =>{
        var datos = elements.profesion.list        
        Object.keys(datos).forEach((element, key, _array) =>{
            if(datos[element].id === elements.profesion.value?.id?.toString()){
                nombreOcupaciones = datos[element].name
                position4 = element
            }
        }) 
    }
    //obtenemos los valores de inconsistencias
    const obtenerInconsistencias = () =>{
        var inconsistencias = elements        
        Object.keys(inconsistencias).forEach((element, key, _array) =>{
            if(inconsistencias[element].elementType === 'date'){
                if(inconsistencias[element].value.getTime() != inconsistencias[element].currentValue.getTime()){
                    saveDataFormulario.objetoInconsistencia[inconsistencias[element].idelement] = inconsistencias[element].currentValue
                }
            }
            else if(inconsistencias[element].idelement === 'departamentoVecindad' || inconsistencias[element].idelement === 'municipioVecindad'
            || inconsistencias[element].idelement === 'departamentoNacimiento' || inconsistencias[element].idelement === 'municipioNacimiento' || inconsistencias[element].idelement === 'paisNacimiento'
            || inconsistencias[element].idelement === 'alfabetismo' || inconsistencias[element].idelement === 'noVidente'
            || inconsistencias[element].idelement === 'genero'
            ){
                if( inconsistencias[element].idelement === 'alfabetismo' || inconsistencias[element].idelement === 'noVidente' || inconsistencias[element].idelement === 'genero'){                
                    if(inconsistencias[element].value.id != inconsistencias[element].currentValue){
                        saveDataFormulario.objetoInconsistencia[inconsistencias[element].idelement] = inconsistencias[element].currentValue
                    }
                }else{
                    if(inconsistencias[element].value?.id != inconsistencias[element].currentValue?.id){
                        if(inconsistencias[element].currentValue?.id === undefined || inconsistencias[element].currentValue?.id === null){
                            saveDataFormulario.objetoInconsistencia[inconsistencias[element].idelement] = ''
                        }else{
                            saveDataFormulario.objetoInconsistencia[inconsistencias[element].idelement] = inconsistencias[element].currentValue.id
                        }
                    }
                }
            }
            else if(inconsistencias[element].value != inconsistencias[element].currentValue 
                && inconsistencias[element].idelement !== 'departamento' && inconsistencias[element].idelement !== 'municipio' && inconsistencias[element].idelement !== 'comunidad'
                && inconsistencias[element].idelement !== 'direccion' && inconsistencias[element].idelement !== 'nocasalote' && inconsistencias[element].idelement !== 'zona'
                && inconsistencias[element].idelement !== 'profesion' && inconsistencias[element].idelement !== 'email'
                && inconsistencias[element].idelement !== 'comunidadResidenciaActualEnElPadron' && inconsistencias[element].idelement !== 'departamentoResidenciaActualEnElPadron'
                && inconsistencias[element].idelement !== 'direccionResidenciaActualEnElPadron' && inconsistencias[element].idelement !== 'municipioResidenciaActualEnElPadron'
                && inconsistencias[element].idelement !== 'noCasaLoteResidenciaActualEnElPadron' && inconsistencias[element].idelement !== 'zonaResidenciaActualEnElPadron'
                && inconsistencias[element].idelement !== 'departamentoCodigoGeoelectoral' && inconsistencias[element].idelement !== 'municipioCodigoGeoelectoral'
                && inconsistencias[element].idelement !== 'comunidadCodigoGeoelectoral' && inconsistencias[element].idelement !== 'centroVotacionCodigoGeoelectoral'
                && inconsistencias[element].idelement !== 'idSolicitudResidenciaRenapExtranjero' && inconsistencias[element].idelement !== 'cuiResidenciaRenapExtranjero'
                && inconsistencias[element].idelement !== 'paisResidenciaRenapExtranjero' && inconsistencias[element].idelement !== 'estadoResidenciaRenapExtranjero'
                && inconsistencias[element].idelement !== 'ciudadResidenciaRenapExtranjero' && inconsistencias[element].idelement !== 'paisResidenciaElectoral'
                && inconsistencias[element].idelement !== 'estadoResidenciaElectoral' && inconsistencias[element].idelement !== 'ciudadResidenciaElectoral'
                && inconsistencias[element].idelement !== 'direccionRenapExtranjero' && inconsistencias[element].idelement !== 'valorDeDireccionRenapExtranjero'
                ){
                    saveDataFormulario.objetoInconsistencia[inconsistencias[element].idelement] = inconsistencias[element].currentValue
            }
        })    
    }    
    const guardarDatosDelFormulario = () =>{
        let datosSolicitudRenap = { objetoInconsistencia:{},
            cui: elements.cui.value, serie: elements.serie.value, fechaEmisionDPI: elements.fechaEmisionDPI.value, 
            departamentoVecindad: elements.departamentoVecindad.value?.id, municipioVecindad: elements.municipioVecindad.value?.id,
            primerNombre: elements.primerNombre?.value?.toUpperCase() || '', segundoNombre: elements.segundoNombre?.value?.toUpperCase() || '', 
            primerApellido: elements.primerApellido?.value?.toUpperCase() || '', segundoApellido: elements.segundoApellido?.value?.toUpperCase() || '', tercerApellido: elements.tercerApellido?.value?.toUpperCase() || '',
            genero: elements.genero.value.id, alfabetismo: elements.alfabetismo.value.id, noVidente: elements.noVidente.value.id, fechaNacimiento: elements.fechaNacimiento.value,
            departamentoNacimiento: elements.departamentoNacimiento.value.id, municipioNacimiento: elements.municipioNacimiento.value.id, 
            nroLibroNacimiento: elements.nroLibroNacimiento.value || '', nroFolioNacimiento: elements.nroFolioNacimiento.value || '', nroPartidaNacimiento: elements.nroPartidaNacimiento.value || '', telefono: elements.telefono.value || '', 
            primerNombrePadre: elements.primerNombrePadre?.value?.toUpperCase() || '', segundoNombrePadre: elements.segundoNombrePadre?.value?.toUpperCase() || '', primerApellidoPadre: elements.primerApellidoPadre?.value?.toUpperCase() || '',
            segundoApellidoPadre: elements.segundoApellidoPadre?.value?.toUpperCase() || '', primerNombreMadre: elements.primerNombreMadre?.value?.toUpperCase() || '', segundoNombreMadre: elements.segundoNombreMadre?.value?.toUpperCase() || '',
            primerApellidoMadre: elements.primerApellidoMadre?.value?.toUpperCase() || '', segundoApellidoMadre: elements.segundoApellidoMadre?.value?.toUpperCase() || '',
            nombreDepartamentoVecindad: elements.departamentoVecindad.value?.name, nombreMunicipioVecindad: elements.municipioVecindad.value?.name,
            nombreDepartamentoNacimiento: elements.departamentoNacimiento.value?.name, nombreMunicipioNacimiento: elements.municipioNacimiento.value?.name,
        }
        return saveDataFormulario = datosSolicitudRenap        
    }
    const validarComunidadCentroVotacion = () =>{
        let data = {comunidad: elements.comunidad.value?.id, cenVotacion: cenVotacion}
        if( (data.comunidad === null || data.comunidad === '' || data.comunidad === undefined) || (data.cenVotacion === null || data.cenVotacion === '' || data.cenVotacion === undefined)){
            elements.comunidad.value = null
            showMessagePersonalizedPosition('warning', 'Advertencia' ,'No se obtuvo comunidad o centro de votación, por favor borre la comunidad y vuelva a seleccionarla.')
            return true;
        }
    }          
    const nextStep=async ()=>{
        if (props.datosCiudadanoTable?.departamentoResidencia?.id === 25 && props.datosCiudadanoTable?.municipioResidencia?.id?.id === 1) {
            guardarDatosDelFormulario()
            obtenerInconsistencias()
            props.SOLICITUD_EMPADRONAMIENTO_SET_INCONSISTENCIAS_RENAP(saveDataFormulario)
            ObtenerNombreOcupaciones()
            props.SOLICITUD_EMPADRONAMIENTO_SET_LUGAR_RESIDENCIA(elements);
            props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(props.step+1);    
        }else{
            guardarDatosDelFormulario()
            obtenerInconsistencias()
            props.SOLICITUD_EMPADRONAMIENTO_SET_INCONSISTENCIAS_RENAP(saveDataFormulario)
            props.SOLICITUD_EMPADRONAMIENTO_SET_ARRAY_LISTADO({ArrayDepartamento: elements.departamento.list, ArrayMunicipio: elements.municipio.list, ArrayComunidad: elements.comunidad.list, ArrayOcupaciones: elements.profesion.list})
            ObtenerNombreComunidad()
            ObtenerNombreOcupaciones()
            props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_RESIDENCIA({nombreDepartamento: nombreDepartamento, nombreMunicipio: nombreMunicipio ,nombreComunidad:nombreComunidad, cenVotacion: cenVotacion, nombreOcupaciones:nombreOcupaciones, position1:position1,position2:position2,position3:position3,position4:position4,})
            if (validarComunidadCentroVotacion()) return;
            else{            
                props.SOLICITUD_EMPADRONAMIENTO_SET_LUGAR_RESIDENCIA(elements);
                props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(props.step+1);    
            }
        }
    };

    const beforeStep=()=>{
        props.SOLICITUD_EMPADRONAMIENTO_SET_ARRAY_LISTADO({ArrayDepartamento: elements.departamento.list, ArrayMunicipio: elements.municipio.list, ArrayComunidad: elements.comunidad.list, ArrayOcupaciones: elements.profesion.list})
        ObtenerNombreComunidad()
        ObtenerNombreOcupaciones()
        props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_RESIDENCIA({nombreDepartamento: nombreDepartamento, nombreMunicipio: nombreMunicipio ,nombreComunidad:nombreComunidad, cenVotacion: cenVotacion, nombreOcupaciones:nombreOcupaciones, position1:position1,position2:position2,position3:position3,position4:position4,})
        props.SOLICITUD_EMPADRONAMIENTO_SET_LUGAR_RESIDENCIA(elements);
        props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(props.step-1); 
    };    

    const Cerrar=()=>{
        elements.direccion.value = ""
        elements.nocasalote.value = ""
        elements.zona.value = ""
        elements.departamento.value = ""
        elements.municipio.value = ""
        elements.comunidad.value = ""            
        elements.profesion.value = ""    
        // elements.observaciones.value = ""    
        elements.departamento.position = ""
        elements.municipio.position = ""
        elements.comunidad.position = ""
        elements.profesion.position = ""
        elements.email.value = ""

        props.data.direccion = ""
        props.data.nocasalote = ""
        props.data.zona = ""
        props.data.departamento = ""
        props.data.municipio = ""
        props.data.comunidad = ""            
        props.data.profesion = ""            
        // props.data.observaciones = ""
        props.data.email = ""
                
        beforeStep()
        props.cerrarDialogo()     
    };    

    const CancelarSolicitud=()=>{
        props.SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD(true)
        props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(props.step+3);
    };
    const ObtenerCentroDeVotacionComunidad = () =>{
        var datos = elements.comunidad.list        
        Object.keys(datos).forEach((element, key, _array) =>{
            if(datos[element].id === elements.comunidad.value.id){
                cenVotacion = datos[element].centroVotacionId
            }
        }) 
    }
    const EnviarSolicitudATSEVirtual=async ()=>{
        if(props.nroBoleta === '' || props.nroBoleta === undefined || props.nroBoleta === null)
            return showMessagePersonalizedPosition('warning','¡Advertencia!','Esta solicitud es una actualización pero en el parámetro no se encuentra adjuntado número de boleta', 'center')

        setLoadingStateCity({loading: true, title:'Generando solicitud TSE Virtual ...'})
        guardarDatosDelFormulario()
        obtenerInconsistencias()
        ObtenerCentroDeVotacionComunidad()
        let saveData = {}
        if (props.datosCiudadanoTable?.departamentoResidencia?.id === 25 && props.datosCiudadanoTable?.municipioResidencia?.id?.id === 1) {
            saveData = {
                idSolicitud: props.datosCiudadanoTable.idSolicitud, nroBoleta: props.nroBoleta, pais: elements.paisResidenciaElectoral.value?.id, 
                estadoResidencia: elements.estadoResidenciaElectoral.value?.id, ciudadResidencia: elements.ciudadResidenciaElectoral.value?.id,
                profesion: elements.profesion.value?.id, email: elements.email.value, 
                departamento: '', municipio: '', comunidad:'', cenVotacion:'', direccion: '', numeroCasa:'', numeroZona: ''
            }
        }else{
            saveData = {
                idSolicitud: props.datosCiudadanoTable.idSolicitud, nroBoleta: props.nroBoleta, departamento: elements.departamento.value?.id, municipio: elements.municipio.value?.id,
                comunidad: elements.comunidad.value?.id, cenVotacion: cenVotacion, direccion: elements.direccion.value, numeroZona: elements.zona.value, numeroCasa: elements.nocasalote.value,
                profesion: elements.profesion.value?.id, email: elements.email.value, pais: '', estadoResidencia: '', ciudadResidencia:'',
                // observaciones: elements.observaciones.value ? elements.observaciones.value.trim() : '', 
            }
        }
        let saveDataComplete = {...saveData, ...saveDataFormulario}
        try {
            const response = await ApiServices.crearSolicitudesDeEmpadronamiento.actualizacionDeRenap(saveDataComplete)
            if(response.error){
                showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
            }else {
                props.actualizarTabla()
                props.cerrarDialogo()
                props.SOLICITUD_EMPADRONAMIENTO_SET_TAB_VALUE_INITIAL(4)
                props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(0);
                showMessagePersonalizedPosition('success','¡BIEN!',response.data.message, 'center')
                props.SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_TSE_VIRTUAL_ENVIADA(response.data.idSolicitud)
                props.ObtenerTotalDeSolicitudesPendientesDeRealizar()
            }             
        } catch (exception) {
            showMessagePersonalizedPosition('error', '¡Advertencia!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
        }
        setLoadingStateCity({loading: false, title:''})
    };    

    const OpenModalReportarCasoAInformatica =() => {
        setAbrirModalReportarCasoInformatica(true)
    }
    const CloseModalReportarCasoAInformatica =() => {
        setAbrirModalReportarCasoInformatica(false)
    }
    const CerrarYActualizar =() => {
        CloseModalReportarCasoAInformatica()
        props.actualizarTabla()
        props.cerrarDialogo()
    }

    const [buttonList,setButtonList]= React.useState({
        "next":{"label":"Asignar Residencia","icon": <NavigateNext />,"callback":nextStep,"loading":false, disabled: props.usuarioEstaEmpadronado, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",},
        "tseVirtual":{"label":"Enviar Solicitud a TSE Virtual","icon": <Send />,"callback":EnviarSolicitudATSEVirtual,disabled: !props.usuarioEstaEmpadronado, showButtonList: !props.usuarioEstaEmpadronado, "loading":false, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",},
        // "reportarCasoAInformatica":{"label":"Reportar Caso a Informática","icon": <ListAlt />,"callback":OpenModalReportarCasoAInformatica,isCancel: true, disabled: false, "loading":false, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",},
    });

    // useEffect(() => {
    //     if(elements.municipioVecindad.list.length > 0) obtenerMuninipiosNacimiento()
    // },[elements.municipioVecindad.list.length > 0])
    // useEffect(() => {
    //     if(elements.departamentoVecindad.list.length > 0) obtenerMuninipiosNacimiento()
    // },[elements.departamentoVecindad.list.length > 0])
    useEffect(() => {
        // setState()
        // setOcupaciones()
        // if(elements.departamento.value && elements.municipio.value && elements.comunidad.value){ setState(); setCity(); setComunidad()};
        // if(elements.comunidad.value){ setComunidad()};
        // if(props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.departamentoVecindad?.id && props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.municipioVecindad?.id) obtenerMuninipiosVecindad();
        // if(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.departamentoNacimiento.id && props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.municipioNacimieno.id) obtenerMuninipiosNacimiento();

        if(props.datosCiudadanoTable.alfabetismo !== undefined){
            ArrayAlfabetismo.forEach((item) =>{
                if(item.id === props.datosCiudadanoTable.alfabetismo) elements.alfabetismo.value = item;
            })
        }
        if(props.datosCiudadanoTable.genero !== undefined){
            ArrayGenero.forEach((item) =>{
                if(item.id === props.datosCiudadanoTable.genero) elements.genero.value = item;
            })            
        }
        if(props.datosCiudadanoTable.noVidente !== undefined){
            ArrayNoVidentePadron.forEach((item) =>{
                if(item.id === props.datosCiudadanoTable.noVidente) elements.noVidente.value = item;
            })            
        }
    }, []);
    const limpiarDatosResidenciaElectoralActual = () => {
        elements.departamentoResidenciaActualEnElPadron.value = ''
        elements.municipioResidenciaActualEnElPadron.value = ''
        elements.comunidadResidenciaActualEnElPadron.value = ''
        elements.direccionResidenciaActualEnElPadron.value = ''
        elements.noCasaLoteResidenciaActualEnElPadron.value = ''
        elements.zonaResidenciaActualEnElPadron.value = ''
    }
    useEffect(() => {
        // if(props.residenciaElectoralActual?.departamentoDeResidencia){
        //     if(props.residenciaElectoralActual?.departamentoDeResidencia){
        //         elements.departamentoResidenciaActualEnElPadron.value = 'Departamento de Residencia: '+(props.residenciaElectoralActual?.departamentoDeResidencia?.name ? props.residenciaElectoralActual?.departamentoDeResidencia?.name:'')
        //         elements.municipioResidenciaActualEnElPadron.value = 'Municipio Residencia: ' + (props.residenciaElectoralActual?.municipioDeResidencia?.municipio ? props.residenciaElectoralActual?.municipioDeResidencia?.municipio:'')
        //         elements.comunidadResidenciaActualEnElPadron.value = 'Comunidad Residencia: ' + (props.residenciaElectoralActual?.comunidadResidencia?.name ? props.residenciaElectoralActual?.comunidadResidencia?.name:'')
        //         elements.direccionResidenciaActualEnElPadron.value = 'Dirección de Residencia: ' + (props.residenciaElectoralActual?.direccion ? props.residenciaElectoralActual?.direccion : '')
        //         elements.noCasaLoteResidenciaActualEnElPadron.value = 'No. Casa/Lote de Residencia: ' + (props.residenciaElectoralActual?.numeroDeCasa ? props.residenciaElectoralActual?.numeroDeCasa : '')
        //         elements.zonaResidenciaActualEnElPadron.value = 'Zona de Residencia: ' + (props.residenciaElectoralActual?.numeroDeZona ? props.residenciaElectoralActual?.numeroDeZona : '')
        //         setCargandoDatos(false)
        //     }else{
        //         setCargandoDatos(true)
        //     }
        // }else {
        //     limpiarDatosResidenciaElectoralActual()            
        //     setCargandoDatos(false)
        // };

        if(props.datosCiudadanoTable?.datosSolicitudEmpadronamiento?.paisNacimiento === 320){
            elements.paisNacimiento.value = {id: 320, name:'Guatemala'}
            elements.paisNacimiento.currentValue = {id: 320, name:'Guatemala'}
        }else{            
            elements.paisNacimiento.value = {id: props.datosCiudadanoTable?.datosSolicitudEmpadronamiento?.descripcionPaisNacimiento?.id, name:props.datosCiudadanoTable?.datosSolicitudEmpadronamiento?.descripcionPaisNacimiento?.nombrePaisExtendido}
            elements.paisNacimiento.currentValue = {id: props.datosCiudadanoTable?.datosSolicitudEmpadronamiento?.descripcionPaisNacimiento?.id, name:props.datosCiudadanoTable?.datosSolicitudEmpadronamiento?.descripcionPaisNacimiento?.nombrePaisExtendido}
        }
    },[props.residenciaElectoralActual])
    useEffect(() => {
        if(props.residenciaElectoralActual?.status){
            elements.departamentoResidenciaActualEnElPadron.value = 'Departamento de Residencia: '+(props.residenciaElectoralActual?.departamentoDeResidencia?.name ? props.residenciaElectoralActual?.departamentoDeResidencia?.name:'')
            elements.municipioResidenciaActualEnElPadron.value = 'Municipio Residencia: ' + (props.residenciaElectoralActual?.municipioDeResidencia?.municipio ? props.residenciaElectoralActual?.municipioDeResidencia?.municipio:'')
            elements.comunidadResidenciaActualEnElPadron.value = 'Comunidad Residencia: ' + (props.residenciaElectoralActual?.comunidadResidencia?.name ? props.residenciaElectoralActual?.comunidadResidencia?.name:'')
            elements.direccionResidenciaActualEnElPadron.value = 'Dirección de Residencia: ' + (props.residenciaElectoralActual?.direccion ? props.residenciaElectoralActual?.direccion : '')
            elements.noCasaLoteResidenciaActualEnElPadron.value = 'No. Casa/Lote de Residencia: ' + (props.residenciaElectoralActual?.numeroDeCasa ? props.residenciaElectoralActual?.numeroDeCasa : '')
            elements.zonaResidenciaActualEnElPadron.value = 'Zona de Residencia: ' + (props.residenciaElectoralActual?.numeroDeZona ? props.residenciaElectoralActual?.numeroDeZona : '')
            setCargandoDatos(false)
        } else if(props.residenciaElectoralActual?.status === false){
            limpiarDatosResidenciaElectoralActual()            
            setCargandoDatos(false)
        }
    },[props.residenciaElectoralActual?.status])

    useEffect(() => {
        if(!props.estaEmpadronado && !props.estaFallecido) {
        // if(!props.estaEmpadronado && !props.estaFallecido && props.eventoRENAP) {
            setDejarEmpadronar(false);
        }
        else {
            setDejarEmpadronar(true);
        } 
    }, [props.estaEmpadronado, props.estaFallecido, props.eventoRENAP]);

    const handleCloseAlertaGeneral = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenAlertaGeneral(false);
        };    
    useEffect(() => {
        if(elements.municipio.value === null) {
            elements.comunidad.value = null
        };
    }, [elements.municipio.value])

    useEffect(() => {
        let newElements= Object. assign({}, elements); 
        
        if(newElements.departamento.value?.id) newElements.departamentoCodigoGeoelectoral.value={title: 'Departamento', value: CentroDeVotacionParseada(elements.departamento.value?.id, 2)};
        else newElements.departamentoCodigoGeoelectoral.value={title: 'Departamento', value: ''};
        if(newElements.municipio.value?.id) newElements.municipioCodigoGeoelectoral.value={title: 'Municipio', value: CentroDeVotacionParseada(elements.municipio.value?.id, 2)};
        else newElements.municipioCodigoGeoelectoral.value={title: 'Municipio', value: ''}

        // newElements.departamentoCodigoGeoelectoral.value={title: 'Departamento', value: elements.departamento.value?.id}
        // newElements.municipioCodigoGeoelectoral.value={title: 'Municipio', value: elements.municipio.value?.id}
        if(elements.departamento.value?.id === undefined) {
            newElements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
            newElements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de votación', value: ''}            
        }
        // if(newElements.comunidadCodigoGeoelectoral.value?.id === undefined) {
        //     newElements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
        //     newElements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de votación', value: ''}            
        // }
        if(newElements.comunidad.value?.id === undefined) {
            newElements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
            newElements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de votación', value: ''}            
        }

        setElements(newElements);
    }, [elements.departamento.value?.id, elements.municipio.value?.id, elements.comunidad.value?.id])
    // validando si es extranjero o nacional
    useEffect(()=>{
        if (props.datosCiudadanoTable?.departamentoResidencia?.id === 25 && props.datosCiudadanoTable?.municipioResidencia?.id?.id === 1) {
            let newElements= Object.assign({}, elements); 
            newElements.departamento.pattern = ''; newElements.departamento.validators = ['requireds']; newElements.departamento.showSelectAutoComplete = false;
            newElements.municipio.pattern = ''; newElements.municipio.validators = ['requireds']; newElements.municipio.showSelectAutoComplete = false;
            newElements.comunidad.pattern = ''; newElements.comunidad.validators = ['requireds']; newElements.comunidad.showSelectAutoComplete = false;
            newElements.direccion.pattern = ''; newElements.direccion.validators = ['requireds']; newElements.direccion.showInputControl = false; newElements.direccion.initialRequiredLength = 0;
            newElements.nocasalote.pattern = ''; newElements.nocasalote.validators = ['requireds']; newElements.nocasalote.showInputControl = false;
            newElements.zona.pattern = ''; newElements.zona.validators = ['requireds']; newElements.zona.showInputControl = false;

            newElements.direccionRenap.show = false;
            newElements.direccionResidenciaRENAP.show =false; 
            newElements.noCasaLoteResidenciaRENAP.show =false;
            newElements.zonaResidenciaRENAP.show =false; 
            newElements.departamentoResidenciaRENAP.show =false; 
            newElements.municipioResidenciaRENAP.show =false; 
            
            newElements.codigoGeoelectoral.show =false; 
            newElements.departamentoCodigoGeoelectoral.show =false; 
            newElements.municipioCodigoGeoelectoral.show =false; 
            newElements.comunidadCodigoGeoelectoral.show =false; 
            newElements.centroVotacionCodigoGeoelectoral.show =false; 


            newElements.paisResidenciaElectoral.showSelectAutoComplete = true
            newElements.estadoResidenciaElectoral.showSelectAutoComplete = true
            newElements.ciudadResidenciaElectoral.showSelectAutoComplete = true
            newElements.profesion.value = null
            return setElements(newElements);
        }else{
            let newElements= Object.assign({}, elements); 
            newElements.paisResidenciaElectoral.pattern = ''
            newElements.paisResidenciaElectoral.validators = ['requireds']
            newElements.paisResidenciaElectoral.showSelectAutoComplete = false

            newElements.estadoResidenciaElectoral.pattern = ''
            newElements.estadoResidenciaElectoral.validators = ['requireds']
            newElements.estadoResidenciaElectoral.showSelectAutoComplete = false

            newElements.ciudadResidenciaElectoral.pattern = ''
            newElements.ciudadResidenciaElectoral.validators = ['requireds']
            newElements.ciudadResidenciaElectoral.showSelectAutoComplete = false

            newElements.departamento.showSelectAutoComplete = true
            newElements.municipio.showSelectAutoComplete = true
            newElements.comunidad.showSelectAutoComplete = true
            newElements.direccion.showInputControl = true
            newElements.nocasalote.showInputControl = true
            newElements.zona.showInputControl = true
            return setElements(newElements);
        }
    },[])
    return (
        <div className={classes.root}>
        <DialogLoadingMessage open={loadingStateCity.loading} title={loadingStateCity.title}/>
            <div className={classes.colorComponente}>
                <Grid >
                    <Grid className={classes.marginText} item xs={12} > 
                        <DatosCiudadano open={props.open} showComponent={false} show={false}/>
                    </Grid>
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div> <br/>
            <div  className={classes.colorComponente}>
                <Grid >
                    <Grid className={classes.marginText} item xs={12}>
                        { !cargandoDatos? 
                            <Form   elements= {elements}  buttonList={buttonList} apiErrors={apiErrors} BotonCerrar={Cerrar} 
                                BotonCancelar={CancelarSolicitud} BotonRegresar={beforeStep}  description={description}
                                // disabled={dejarEmpadronar} 
                            />
                            : <LoadingSpinner open={cargandoDatos}></LoadingSpinner>
                        }
                    </Grid>                                       
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div><br/>
            <ComponenteReportarCasoAInformatica open={abrirModalReportarCasoInformatica} closeModal={CloseModalReportarCasoAInformatica}
                idSolicitud={props.datosCiudadanoTable.idSolicitud} CerrarYActualizar={CerrarYActualizar}
            ></ComponenteReportarCasoAInformatica>
            <Snackbar open={openAlertaGeneral} onClose={handleCloseAlertaGeneral}>
                <Alert variant="filled" severity="info" elevation={6} onClose={handleCloseAlertaGeneral}>
                    NOTA: Si en el campo “Apellido de Casada” trae información, verificar si trae el “De” de casada, si no trae el “De” en el apellido de casada, agregar el “De” de forma manual de lo contrario no agregar nada.
                </Alert>
            </Snackbar>
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosCiudadanoRENAP);